// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"485":"f4026695","896":"a4aea7ca"}[chunkId] + ".js";
};